import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { AdminLayout } from "../AdminPages";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });

const Option = ({ id, title, line, on, disabled, onPick, busy }) => (
  <button type="button" onClick={onPick} disabled={disabled || on || busy} data-testid={`payments-pick-${id}`}
    className={`w-full rounded-xl border p-4 text-left transition-colors ${on ? "border-emerald-500 bg-emerald-50" : "border-black/15 hover:bg-black/5"} disabled:cursor-not-allowed`}>
    <p className="font-semibold">{title} {on && <span className="ml-2 text-xs text-emerald-700">● Taking payments now</span>}</p>
    <p className="text-sm opacity-70">{line}</p>
  </button>
);

export default function AdminPayments() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/api/admin/payments/provider`, auth()).then((r) => setS(r.data)); }, []);
  const pick = async (provider) => {
    setBusy(true); setErr("");
    try { setS((await axios.post(`${API}/api/admin/payments/provider`, { provider }, auth())).data); }
    catch { setErr("Couldn't switch. Paddle's keys aren't all set yet."); }
    finally { setBusy(false); }
  };
  return (
    <AdminLayout>
      <div className="max-w-2xl space-y-4" data-testid="admin-payments-page">
        <h1 className="text-2xl font-semibold">Payments</h1>
        <p className="text-sm opacity-70">Stripe takes every membership payment. If Stripe ever pauses your account, switch to Paddle here and every checkout (golf page, demo, My voice) moves over instantly. Same plans, same prices.</p>
        {!s ? <Loader2 className="animate-spin" /> : (
          <>
            <Option id="stripe" title="Stripe (main)" line="Cards, Apple Pay and Google Pay." on={s.active === "stripe"} busy={busy} onPick={() => pick("stripe")} />
            <Option id="paddle" title="Paddle (backup)" line={s.paddle_missing.length ? `Not ready yet. Missing: ${s.paddle_missing.join(", ")}` : `Ready (${s.paddle_env}).`}
              on={s.active === "paddle"} disabled={s.paddle_missing.length > 0} busy={busy} onPick={() => pick("paddle")} />
            {err && <p className="text-sm text-red-600" data-testid="payments-error">{err}</p>}
            <p className="text-xs opacity-60">Paddle webhook address to paste into Paddle → Developer tools → Notifications: <code data-testid="payments-webhook-url">{`${API}/api/paddle/webhook`}</code></p>
          </>
        )}
      </div>
    </AdminLayout>
  );
}
